import { useCapabilities } from "src/hooks/useCapabilities";
import { useIsCaseManagementEnabled } from "src/hooks/useIsCaseManagementEnabled";
import { useWorkspaceFeatureGates } from "src/hooks/useWorkspaceFeatureGates";

export const useIsSidebarLayout = (): boolean => {
  const { entitiesEnabled, featuresEventsEnabled } = useWorkspaceFeatureGates();
  const { isEnabled: isCaseManagementEnabled } = useIsCaseManagementEnabled();
  const capabilities = useCapabilities();

  return (
    entitiesEnabled ||
    featuresEventsEnabled ||
    (isCaseManagementEnabled && capabilities.cases.canAccess)
  );
};
